import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import Paper from "commons/ui/Paper";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";

import useMaterialSubcategoryForm from "hooks/form/useMaterialSubcategoryForm";

function MaterialSubcategoryForm({ materialSubcategoryId }: { materialSubcategoryId?: string }) {
    const { formHook } = useMaterialSubcategoryForm({ materialSubcategoryId });

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridItem>
            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <Paper>
                        <GridColumn>
                            <GridRow className="title-margin">
                                <GridItem>
                                    <h2>Italiano</h2>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={"Nome"}
                                        startAdornment={TwoLanguagesAdornment("it")}
                                        value={form.text.it.name}
                                        setValue={setValue}
                                        path={"text.it.name"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>

                            <GridRow className="title-margin">
                                <GridItem>
                                    <h2>Inglese</h2>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={"Nome"}
                                        startAdornment={TwoLanguagesAdornment("en")}
                                        value={form.text.en.name}
                                        setValue={setValue}
                                        path={"text.en.name"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>
                        </GridColumn>
                    </Paper>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

export default MaterialSubcategoryForm;
